import React, { Component } from "react";
import { Helmet } from "react-helmet";

import "./../../../node_modules/react-dropzone-component/styles/filepicker.css";
import "./../../../node_modules/dropzone/dist/min/dropzone.min.css";
import "./profileFormDocs.css";
import UploadDocument from "../uploadDocument/UploadDocument";
export default class ProfileFormDocs extends Component {
  render() {
    return (
      <div className="profile-docs">
        <Helmet>
          <title>{`Profile | Documents`}</title>
        </Helmet>
        <UploadDocument
          className="profile-docs__upload"
          title="Photo ID"
          name="photoId"
        />
        <UploadDocument
          className="profile-docs__upload"
          title="Employment Letter"
          name="employmentLetter"
        />
        <UploadDocument
          className="profile-docs__upload"
          title="Credit Report"
          name="creditReport"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profileFormDocs/ProfileFormDocs.js